import {IState, ACTION_VERBS} from './Types';

import {parser} from './Parser';

/**
 *
 */
export const initialState: IState = {
  errors: [],
  clients: null,
  clientTerritories: [],
  customerTypes: [],
  clientProductList: null,
  customerPaymentOptions: [],
  balanceSheet: null,
  clientCities: [],
  clientCategories: [],
  clientPortfolioFilter: null,
  semaphoreItems: null,
  filterTracking: null,
  balances: null,
  debtors: null,
};

/**
 *
 * @param state
 * @param action
 * @returns
 */
export const reducer = (state: IState, action: any) => {
  const {
    CLEAR_ERRORS,
    BALANCE_SHEET,
    GET_SALESMAN_PRODUCTS,
    FETCH_BALANCE_CLIENT,
    SALESMAN_RESOURCES,
    SEMAPHORE_ITEMS,
    SET_PORTFOLIO_FILTER,
    SET_FILTER_TRACKING,
    DEBTOR_LIST,
  } = ACTION_VERBS;
  const cleaning = {...state, errors: []};

  switch (action.type) {
    case CLEAR_ERRORS:
      return {
        ...cleaning,
      };
    case BALANCE_SHEET:
      return {
        ...parser.balanceSheetSalesman(state, action.payload),
      } as IState;

    case GET_SALESMAN_PRODUCTS:
      return {
        ...parser.salesmanProductList(state, action.payload),
      } as IState;

    case FETCH_BALANCE_CLIENT:
      return {
        ...parser.fetchBalanceCustomer(state, action.payload),
      } as IState;

    case SALESMAN_RESOURCES:
      return {
        ...parser.processResources(state, action.payload),
      } as IState;

    case SEMAPHORE_ITEMS:
      return {
        ...parser.semaphoreItems(state, action.payload),
      } as IState;

    case SET_PORTFOLIO_FILTER:
      return {
        ...parser.setPortfolioFilter(state, action.payload),
      } as IState;
    case DEBTOR_LIST:
      return {
        ...parser.debtorList(state, action.payload),
      } as IState;
    case SET_FILTER_TRACKING:
      return {
        ...parser.setFilterTracking(state, action.payload),
      } as IState;
    default:
      return state;
  }
};
